import { buildDownloadDataNew } from '@intelligence/utils/commonUtils';
import { mergeCommonDetailsData } from '../../utils';
import {
  buildPublisherConfigs,
  buildGenreConfigs,
  buildReleaseDateConfigs,
  buildDateConfigs,
} from './common';


export const getMarketProfileStatsConfig = (data: any, params: any, allParams: any) => {
  // console.debug('getMarketProfileStatsConfigdata', data)
  // console.debug('getMarketProfileStatsConfigparams', params)
  // console.debug('getMarketProfileStatsConfigallParams', allParams);
  // 指标数组
  const metricListTemp = allParams?.download_metrics || [];
  const METRIC_LIST = ['operation', 'games', 'main_genres', 'sub_genres', 'companies'];
  // 过滤下载指标
  const metricList = METRIC_LIST?.filter((item: string) => metricListTemp?.includes(item));
  const regionOptions = allParams?.regionOptions || [];
  const publisherConfigs = buildPublisherConfigs({ ...allParams, company_show: 1 }, regionOptions);
  const genreConfigs = buildGenreConfigs({ ...allParams, genre_show: 1 });
  const releaseDateConfigs = buildReleaseDateConfigs({ ...allParams, release_date_show: 1 });
  const dateConfigs = buildDateConfigs(allParams);
  // 是否展示%
  const isShowRatio = allParams?.ratio_show === 1;
  const isByTime = allParams?.downlaod_date_method === 'separate';
  // 需要下载的指标映射
  const metricMap: IRecord<boolean> =
    params?.metrics?.reduce((acc: IRecord<boolean>, cur: string) => {
      return { ...acc, [cur]: true };
    }, {}) ?? {};

  const commonSheetConfig = [
    {
      title: 'Digital Revenue(mscience)',
      key: (item: any) => item?.mscience__digitalRevenue || '',
      when: () => metricMap?.mscience__digitalRevenue,
    },
    {
      title: '%',
      key: (item: any) => item?.mscience__digitalRevenue_ratio || '',
      when: () => isShowRatio && metricMap?.mscience__digitalRevenue,
    },
    {
      title: 'Physical Revenue(npd)',
      key: (item: any) => item?.npd__revenue || '',
      when: () => metricMap?.npd__revenue,
    },
    {
      title: '%',
      key: (item: any) => item?.npd__revenue_ratio || '',
      when: () => isShowRatio && metricMap?.npd__revenue,
    },
  ];

  const operationSheetConfig = [
    // {
    //   title: 'Date',
    //   key: (item: any) => {
    //     const itemDate = item?.date || '';
    //     return granularity === 'monthly' ? formatDateStr(itemDate, 'YYYY-MM') : itemDate;
    //   },
    //   when: () => isGroupByDate,
    // },
    ...dateConfigs,
    ...commonSheetConfig,
  ];
  const gamesSheetConfig = [
    {
      title: 'Game Name',
      key: (item: any) => item?.entity_name || '',
    },
    ...publisherConfigs,
    ...genreConfigs,
    ...releaseDateConfigs,
    ...dateConfigs,
    ...commonSheetConfig,
    // {
    //   title: 'MAU(newzoo)',
    //   key: (item: any) => item?.newzoo__mau || '',
    //   when: () => metricMap?.newzoo__mau,
    // },
    // {
    //   title: '%',
    //   key: (item: any) => item?.newzoo__mau_ratio || '',
    //   when: () => isShowRatio && metricMap?.newzoo__mau,
    // },
  ];
  const mainGenresSheetConfig = [
    {
      title: 'Genre',
      key: (item: any) => item?.genre || '',
    },
    ...dateConfigs,
    {
      title: 'Digital Revenue(mscience)',
      key: (item: any) => item?.mscience__digitalRevenue || '',
      when: () => metricMap?.mscience__digitalRevenue,
    },
    {
      title: '% of Market Digital Revenue',
      key: (item: any) => item?.mscience__digitalRevenue_share || '',
      when: () => metricMap?.mscience__digitalRevenue_share,
    },
    {
      title: 'Physical Revenue(npd)',
      key: (item: any) => item?.npd__revenue || '',
      when: () => metricMap?.npd__revenue,
    },
    {
      title: '% of Market Physical Revenue',
      key: (item: any) => item?.npd__revenue_share || '',
      when: () => metricMap?.npd__revenue_share,
    },
  ];
  const subGenresSheetConfig = [
    {
      title: 'Genre',
      key: (item: any) => item?.genre || '',
    },
    {
      title: 'Sub Genre',
      key: (item: any) => item?.sub_genre || '',
    },
    ...dateConfigs,
    {
      title: 'Digital Revenue(mscience)',
      key: (item: any) => item?.mscience__digitalRevenue || '',
      when: () => metricMap?.mscience__digitalRevenue,
    },
    {
      title: 'Physical Revenue(npd)',
      key: (item: any) => item?.npd__revenue || '',
      when: () => metricMap?.npd__revenue,
    },
  ];

  const companiesSheetConfig = [
    {
      title: 'Rank',
      key: (item: any) => item?.rank || '',
    },
    {
      title: 'Publisher Company Name',
      key: (item: any) => item?.name || '',
    },
    {
      title: 'City',
      key: (item: any) => item?.location_identifiers_city || '',
    },
    {
      title: 'Country',
      key: (item: any) => item?.location_identifiers_country || '',
    },
    ...dateConfigs,
    ...commonSheetConfig,
  ];

  // 动态根据metricList数组元素个数,动态生成sheet配置,
  const sheetNameMap = {
    operation: 'Operation Data',
    games: 'Game Data',
    main_genres: 'Main Genre Data',
    sub_genres: 'Sub Genre Data',
    companies: 'Companies',
  } as any;
  const sheetConfigMap = {
    operation: operationSheetConfig,
    games: gamesSheetConfig,
    main_genres: mainGenresSheetConfig,
    sub_genres: subGenresSheetConfig,
    companies: companiesSheetConfig,
  } as any;
  const getDataConfig = (item: any, index: number, pageName: string) => {
    switch (pageName) {
      case 'operation':
        return buildDownloadDataNew(sheetConfigMap[item], mergeCommonDetailsData(data[index]?.list, {}, isByTime));
      case 'games':
        return buildDownloadDataNew(
          sheetConfigMap[item],
          mergeCommonDetailsData(data?.[index]?.list, data?.[index]?.ext?.entity_info, isByTime, 'game_id'),
        );
      case 'main_genres':
        return buildDownloadDataNew(
          sheetConfigMap[item],
          mergeCommonDetailsData(data[index]?.list, {}, isByTime, 'genre'),
        );
      case 'sub_genres':
        return buildDownloadDataNew(
          sheetConfigMap[item],
          mergeCommonDetailsData(data[index]?.list, {}, isByTime, 'sub_genre'),
        );
      case 'companies':
        return buildDownloadDataNew(
          sheetConfigMap[item],
          mergeCommonDetailsData(data?.[index]?.list, data?.[index]?.ext?.entity_info, isByTime, 'company_id'),
        );
      default:
        return buildDownloadDataNew(sheetConfigMap[item], mergeCommonDetailsData(data[index]?.list, {}, isByTime));
    }
  };

  const sheets: any = {};
  metricList.forEach((item: any, index: any) => {
    sheets[`sheet${index + 1}`] = {
      sheetName: sheetNameMap[item],
      style: 'normal',
      data: getDataConfig(item, index, item),
    };
  });

  return sheets;
};
